"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _localization = require("@lt/localization");
var _userflow = _interopRequireDefault(require("../../styles/userflow"));
var _Selector = _interopRequireDefault(require("../Selector"));
var _Collapsible = _interopRequireDefault(require("../Collapsible"));
var _MobileSelector = _interopRequireDefault(require("../MobileSelector"));
var _FileLoader = _interopRequireDefault(require("../FileLoader"));
var _components = require("./components");
var _utils = require("./utils");
var OrderCancellation = function OrderCancellation(props) {
  var _cancellationReasons$;
  var _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    _props$isMobile = props.isMobile,
    isMobile = _props$isMobile === void 0 ? false : _props$isMobile,
    _props$cancellationRe = props.cancellationReasons,
    cancellationReasons = _props$cancellationRe === void 0 ? [] : _props$cancellationRe,
    _props$onSubmit = props.onSubmit,
    _onSubmit = _props$onSubmit === void 0 ? Function.prototype : _props$onSubmit,
    _props$fileLoader = props.fileLoader,
    fileLoader = _props$fileLoader === void 0 ? {} : _props$fileLoader,
    _props$onCancellation = props.onCancellationReasonChange,
    onCancellationReasonChange = _props$onCancellation === void 0 ? Function.prototype : _props$onCancellation,
    _props$onReasonTextCh = props.onReasonTextChange,
    onReasonTextChange = _props$onReasonTextCh === void 0 ? Function.prototype : _props$onReasonTextCh,
    isHotelOnly = props.isHotelOnly,
    refundText = props.refundText,
    _props$isRequestCance = props.isRequestCancellation,
    isRequestCancellation = _props$isRequestCance === void 0 ? false : _props$isRequestCance;
  var _useTranslation = (0, _localization.useTranslation)(),
    t = _useTranslation.t;
  var searchType = isHotelOnly ? 'hotel' : 'package';
  var _React$useState = _react["default"].useState(),
    _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
    cancellationReason = _React$useState2[0],
    setCancellationReason = _React$useState2[1];
  var _React$useState3 = _react["default"].useState(false),
    _React$useState4 = (0, _slicedToArray2["default"])(_React$useState3, 2),
    mobileSelectVisible = _React$useState4[0],
    setMobileSelectVisible = _React$useState4[1];
  var buttonTitle = (0, _utils.getButtonTitle)(searchType, isRequestCancellation);
  var confirmationTitle = "".concat(t('orderPage.orderCancellation.confirmationTitle', {
    context: searchType
  }));
  var hasNoSelectedReason = cancellationReason === undefined;
  var mobileSelect = /*#__PURE__*/_react["default"].createElement(_MobileSelector["default"], {
    options: cancellationReasons,
    onSelect: function onSelect(o) {
      setCancellationReason(o);
      onCancellationReasonChange(o);
      setMobileSelectVisible(false);
    },
    popup: {
      visible: mobileSelectVisible,
      onClick: function onClick() {
        return setMobileSelectVisible(false);
      }
    }
  });
  var desktopSelect = /*#__PURE__*/_react["default"].createElement(StyledSelector, {
    selected: cancellationReason,
    defaultValue: t('orderPage.orderCancellation.reasonText'),
    options: cancellationReasons,
    onSelected: function onSelected(o) {
      setCancellationReason(o);
      onCancellationReasonChange(o);
    },
    isMobile: false
  });
  var shouldRenderFileLoader = (_cancellationReasons$ = cancellationReasons.find(function (reason) {
    return reason.id === (cancellationReason === null || cancellationReason === void 0 ? void 0 : cancellationReason.id);
  })) === null || _cancellationReasons$ === void 0 ? void 0 : _cancellationReasons$.needsDoc;
  var showCustomReasonInput = (cancellationReason === null || cancellationReason === void 0 ? void 0 : cancellationReason.value) === "Другое";
  var reasonText = hasNoSelectedReason ? t('orderPage.orderCancellation.reasonText') : cancellationReason === null || cancellationReason === void 0 ? void 0 : cancellationReason.value;
  var fakeMobileSelect = /*#__PURE__*/_react["default"].createElement(StyledFakeMobileSelect, {
    onClick: function onClick() {
      return setMobileSelectVisible(true);
    }
  }, reasonText);
  return /*#__PURE__*/_react["default"].createElement(StyledOrderCancellation, {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(StyledOrderCancellationBody, null, isMobile ? fakeMobileSelect : desktopSelect, isMobile ? mobileSelect : null, /*#__PURE__*/_react["default"].createElement(_Collapsible["default"], {
    isCollapsed: hasNoSelectedReason
  }, /*#__PURE__*/_react["default"].createElement(_components.Attachments, {
    description: cancellationReason === null || cancellationReason === void 0 ? void 0 : cancellationReason.description
  }), shouldRenderFileLoader ? /*#__PURE__*/_react["default"].createElement(StyledFileLoader, (0, _extends2["default"])({}, fileLoader, {
    isMobile: isMobile
  })) : null, showCustomReasonInput ? /*#__PURE__*/_react["default"].createElement(StyledCustomReason, null, /*#__PURE__*/_react["default"].createElement(StyledReasonInput, {
    isMobile: isMobile,
    onChange: function onChange(e) {
      return onReasonTextChange(e.target.value);
    }
  })) : null, /*#__PURE__*/_react["default"].createElement(StyledSubmitBlock, {
    buttonTitle: buttonTitle,
    confirmationTitle: confirmationTitle,
    onSubmit: function onSubmit() {
      return _onSubmit();
    },
    isMobile: isMobile
  }, /*#__PURE__*/_react["default"].createElement(StyledSubmitText, {
    dangerouslySetInnerHTML: {
      __html: refundText !== null && refundText !== void 0 ? refundText : ''
    }
  })))));
};
var StyledCustomReason = _styledComponents["default"].div.withConfig({
  displayName: "OrderCancellation__StyledCustomReason",
  componentId: "sc-1a4t04y-0"
})(["padding:8px 16px;display:flex;flex-direction:column;font-size:14px;line-height:16px;margin-bottom:10px;color:", ";"], _userflow["default"].colors.blackLight);
var StyledReasonInput = _styledComponents["default"].input.withConfig({
  displayName: "OrderCancellation__StyledReasonInput",
  componentId: "sc-1a4t04y-1"
})(["border:1px solid ", ";box-sizing:border-box;border-radius:4px;padding:8px 12px;outline:none;margin-top:4px;width:", ";;"], _userflow["default"].colors.whiteLight, function (_ref) {
  var isMobile = _ref.isMobile;
  return isMobile ? '100%' : '60%';
});
var StyledOrderCancellation = _styledComponents["default"].div.withConfig({
  displayName: "OrderCancellation__StyledOrderCancellation",
  componentId: "sc-1a4t04y-2"
})(["display:flex;flex-direction:column;"]);
var StyledOrderCancellationBody = _styledComponents["default"].div.withConfig({
  displayName: "OrderCancellation__StyledOrderCancellationBody",
  componentId: "sc-1a4t04y-3"
})(["background-color:#f5f3f2;border-radius:4px;"]);
var StyledSubmitBlock = (0, _styledComponents["default"])(_components.SubmitBlock).withConfig({
  displayName: "OrderCancellation__StyledSubmitBlock",
  componentId: "sc-1a4t04y-4"
})(["background-color:", ";"], _userflow["default"].colors.pinkBase);
var StyledSubmitText = _styledComponents["default"].div.withConfig({
  displayName: "OrderCancellation__StyledSubmitText",
  componentId: "sc-1a4t04y-5"
})(["color:", ";margin-bottom:8px;font-size:14px;"], _userflow["default"].colors.blackBase);
var StyledSelector = (0, _styledComponents["default"])(_Selector["default"]).withConfig({
  displayName: "OrderCancellation__StyledSelector",
  componentId: "sc-1a4t04y-6"
})(["margin-left:16px;"]);
var StyledFakeMobileSelect = _styledComponents["default"].div.withConfig({
  displayName: "OrderCancellation__StyledFakeMobileSelect",
  componentId: "sc-1a4t04y-7"
})(["font-size:16px;line-height:20px;color:#007aff;padding:8px 16px;"]);
var StyledFileLoader = (0, _styledComponents["default"])(_FileLoader["default"]).withConfig({
  displayName: "OrderCancellation__StyledFileLoader",
  componentId: "sc-1a4t04y-8"
})(["padding:8px 16px;"]);
var _default = exports["default"] = OrderCancellation;